import React, {FC} from 'react';
import {SessionProvider} from './sessionStore/session.hooks';
import {WishlistProvider} from './wishlistStore/wishlist.hooks';
import {UserProvider} from './userStore/user.hooks';
import {CustomerProvider} from './customer/customer.hooks';
import {MinimalStateProvider} from './basketStore/useBasketMinimalState';
import {BasketTokenProvider} from './basketStore/BasketTokenProvider';

export const UserStateProvider: FC<
  React.PropsWithChildren<{
    UserSelectedDiscountProvider: FC<React.PropsWithChildren>;
  }>
> = ({children, UserSelectedDiscountProvider}) => {
  return (
    <SessionProvider>
      <UserProvider>
        <UserSelectedDiscountProvider>
          <BasketTokenProvider>
            <MinimalStateProvider>
              <CustomerProvider>
                <WishlistProvider>{children}</WishlistProvider>
              </CustomerProvider>
            </MinimalStateProvider>
          </BasketTokenProvider>
        </UserSelectedDiscountProvider>
      </UserProvider>
    </SessionProvider>
  );
};
